import { AggregateDescriptor, DataResult, GroupDescriptor, State } from '@progress/kendo-data-query'
import { ReactNode, createContext, useContext, useState } from 'react'
import {
    createAppState,
    processWithGroups,
} from '../Components/GridComponents/ARAgingGridFunctions'
import { setExpandedState } from '@progress/kendo-react-data-tools'

interface ContextValue {
    appState: AppState
    setAppState: React.Dispatch<React.SetStateAction<AppState>>
    dataState: State
    setDataState: React.Dispatch<React.SetStateAction<State>>
    collapsedState: string[]
    setCollapsedState: React.Dispatch<React.SetStateAction<any[]>>
    operationsResult: DataResult
    setOperationsResult: React.Dispatch<React.SetStateAction<DataResult>>
    dataAvailable:ARAgingGridInvoice[] 
    setDataAvailable:React.Dispatch<React.SetStateAction<ARAgingGridInvoice[]>>
    gridLoading:boolean
    setGridLoading:React.Dispatch<React.SetStateAction<boolean>>
    currentPage:number,
    setCurrentPage:React.Dispatch<React.SetStateAction<number>>
}
const DashboardContext = createContext<ContextValue | undefined>(undefined)
export const aggregates: AggregateDescriptor[] = [{ field: 'AmountDue', aggregate: 'sum' }]
const groupDescriptor: GroupDescriptor[] = [{ field: 'EntityName', aggregates: aggregates }]

export const pageDataState: State = {
    group: groupDescriptor,
}
interface MyContextProviderProps {
    children: ReactNode
}
export const MyContextProvider: React.FC<MyContextProviderProps> = ({ children }) => {
    const [gridLoading, setGridLoading] = useState(false)
    const [dataAvailable, setDataAvailable] = useState<ARAgingGridInvoice[]>([])
    const [dataState, setDataState] = useState<State>(pageDataState)
    const [collapsedState, setCollapsedState] = useState<string[]>([])
    const [operationsResult, setOperationsResult] = useState<DataResult>(
        processWithGroups(dataAvailable?dataAvailable:[], pageDataState, aggregates)
    )
    const data = setExpandedState({
        data: operationsResult.data,
        collapsedIds: collapsedState,
    })
    const [appState, setAppState] = useState<AppState>(createAppState(0, 5, data))
    const [currentPage,setCurrentPage]=useState<number>(1)
    return (
        <DashboardContext.Provider
            value={{
                gridLoading,
                setGridLoading,
                dataAvailable,
                setDataAvailable,
                appState,
                dataState,
                setDataState,
                collapsedState,
                setCollapsedState,
                operationsResult,
                setOperationsResult,
                setAppState,
                currentPage,
                setCurrentPage
            }}
        >
            {children}
        </DashboardContext.Provider>
    )
}

export const useDashboardContext = (): ContextValue => {
    const context = useContext(DashboardContext)
    if (context === undefined) {
        throw new Error('useMyContext must be used within a MyContextProvider')
    }
    return context
}

export default DashboardContext
